import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoNmg: CultureInfo = {
  name: 'nmg',
  displayName: 'nmg',
  iso3LanguageCode: 'nmg',
  iso2LanguageCode: 'nmg',
  ietfLanguageTag: 'nmg',
  parent: null
};
